import React from "react";

import config from "shared/config";

import {
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
  HelpBlock,
} from "react-bootstrap";

// Base class for formState-based input fields, what it does:
// - Connect input's update handler with formState
// - Wraps input field in bootstrap form boilerplate, including
//   the proper validation state class
//
// See inline method descriptions and FormState docs for more info
export default class FsInput extends React.Component {
  // Retrieve input value from DOM event
  // Please overwrite in inheriting class if input event has non-default behavior
  getValueFromUpdate(event) {
    return event.target.value;
  }

  // Get validation state from formState + transform it into bootstrap css
  getBootstrapValidationState() {
    const validationState = this.props.formState.readFormAttributeValidation(
      this.props.attribute,
    );
    const validationMode = this.props.formState.readValidationMode(
      this.props.attribute,
    );

    if (!validationMode) {
      return null;
    }

    return validationState == null
      ? null
      : validationState === false
      ? "error"
      : "success";
  }

  // Calculates a controlId for bootstrap
  getControlId() {
    return `form_${this.props.attribute}`;
  }

  // Let input change update formState
  // Please overwrite in inheriting class if input has non-default behavior
  update(event) {
    this.props.formState.updateFormAttribute(
      this.props.attribute,
      this.getValueFromUpdate(event),
    );
  }

  // The actual input component JSX
  // Needs to be overwritten in inheriting class and call update() function
  // on changes
  // See FsText for a simple example
  renderInput() {
    throw new Error("abstract");
  }

  // Wraps some boilerplate bootstrap form markup around input
  render() {
    if (!this.props.formState || !this.props.attribute) {
      return null;
    }

    return (
      <FormGroup
        controlId={this.getControlId()}
        validationState={this.getBootstrapValidationState()}
      >
        <Col
          componentClass={ControlLabel}
          sm={this.props.labelColumnCount || config.formLabelColumnCount}
        >
          {this.props.label}
        </Col>

        <Col
          sm={this.props.inputColumnCount || config.formInputColumnCount}
          className="pull-right"
        >
          {this.renderInput()}
          <FormControl.Feedback />
          <HelpBlock>{this.props.help}</HelpBlock>
          {this.props.additionalNote && (
            <HelpBlock>{this.props.additionalNote}</HelpBlock>
          )}
        </Col>
      </FormGroup>
    );
  }
}
